import { useContext } from "react";
import { AppContext, AppContextType } from "../containers/AppContainer/AppContainer";

const useAppContext = (): AppContextType => {
  return useContext(AppContext);
};

export default useAppContext;
